<template>
  <div>
    <cooperation-search-head
      :titleInfo="titleInfo"
      :bgUrl="bgUrl"
      @handSearch="handSearch"
      :companyList="companyList"
      :showDropSelect="true"
    >
    </cooperation-search-head>
    <div class="cooperation-visa-index-container">
      <div class="visa-change-head">
        <div class="visa-change-head-title">
          <cooperation-title-cp
            title="变更概览"
            :bg="false"
            type="choose"
            @chooseAllOrMonth="chooseAllOrMonth"
          ></cooperation-title-cp>
        </div>
        <div class="visa-details-container">
          <template v-if="tabKey == '累计'">
            <div class="top">
              <div>
                <span>一单一估</span>
                <span>{{ body.adYdygvalue | money2 }}</span>
                <span>累计金额</span>
              </div>
              <div>
                <span></span>
                <span>{{ body.adYdygnumber }}&nbsp;份</span>
                <span>累计份数</span>
              </div>
            </div>
            <div class="bottom">
              <div>
                <span>一单一结</span>
                <span>{{ body.adYdyjdeclareAmount | money2 }}</span>
                <span>申报金额</span>
              </div>
              <div>
                <span></span>
                <span>{{ body.adYdyjconfirmAmount | money2 }}</span>
                <span>确认金额</span>
              </div>
              <div>
                <span></span>
                <span>{{ body.adYdyjconfirmNumber }}&nbsp;份</span>
                <span>确认份数</span>
              </div>
            </div>
          </template>
          <template v-else>
            <div class="top">
              <div>
                <span>一单一估</span>
                <span>{{ body.cmYdygvalue | money2 }}</span>
                <span>本月金额</span>
              </div>
              <div>
                <span></span>
                <span>{{ body.cmYdygnumber }}&nbsp;份</span>
                <span>本月份数</span>
              </div>
            </div>
            <div class="bottom">
              <div>
                <span>一单一结</span>
                <span>{{ body.cmYdyjdeclareAmount | money2 }}</span>
                <span>申报金额</span>
              </div>
              <div>
                <span></span>
                <span>{{ body.cmYdyjconfirmAmount | money2 }}</span>
                <span>确认金额</span>
              </div>
              <div>
                <span></span>
                <span>{{ body.cmYdyjconfirmNumber }}&nbsp;份</span>
                <span>确认份数</span>
              </div>
            </div>
          </template>
        </div>
      </div>
      <div class="visa-change-mine">
        <div class="title" @click="detailClick">
          <cooperation-title-cp
            title="我的签证变更"
            :bg="false"
          ></cooperation-title-cp>
        </div>
        <van-list
          :offset="30"
          v-model="loading"
          :finished="finished"
          :immediate-check="false"
          finished-text="没有更多了"
          @load="onLoad"
        >
          <van-cell v-for="(item, index) in list" :key="index">
            <template>
              <div class="mine-item">
                <mineVisaChange :item="item"></mineVisaChange>
                <div class="mine-item-bg"></div>
              </div>
            </template>
          </van-cell>
        </van-list>
      </div>
    </div>
  </div>
</template>

<script>
import cooperationTitleCp from '../components/title-cp';
import mineVisaChange from './cooperation-packge/components/cooperation-my-visa-change-cp';
import cooperationSearchHead from './cooperation-packge/components/cooperation-search-head-cp';

import { List, PullRefresh, Sticky } from 'vant';
import { getUrlParams } from 'common/js/mUtils';

export default {
  name: 'cooperation-visa-index',

  data() {
    return {
      testData: [1, 2, 3, 4, 5, 6, 7, 8, 9],
      body: {},
      catch: {},
      list: [],
      loading: true,
      finished: false,
      refreshing: false,
      current: 1,
      size: 10,
      providerGuid: '',
      tabKey: '累计',
      companyList: [],
      params: {},
      titleInfo: {
        selectname: '申报日期',
        selectTitle: '申报日期'
      },
      bgUrl: '',
      watertext: '',
      watermobile: ''
    };
  },
  created() {
    let { providerGuid, employeeName, mobile } = getUrlParams();
    this.watertext = decodeURIComponent(employeeName) || '';
    this.watermobile = mobile;
    let params = {
      providerGuid,
      current: this.current,
      size: this.size
    };
    this.providerGuid = providerGuid;

    this._getVisaStatistics(params);
    this._getVisaList(params);
    this._getComplay({ type: 'visaChange' });
    this.$api.getBannerList({ current: 1, size: 999 }).then(res => {
      let { code, body } = res;
      if (code == '0000') {
        let { records } = body;
        records = records.filter(item => item.position == 6);
        this.bgUrl = records.length && records[0].image;
      }
    });
  },
  components: {
    cooperationTitleCp,
    mineVisaChange,
    cooperationSearchHead,
    [Sticky.name]: Sticky,
    [List.name]: List,
    [PullRefresh.name]: PullRefresh
  },

  methods: {
    _getComplay({ type }) {
      let { providerGuid } = getUrlParams();
      this.$api
        .getCompanyList({
          providerGuid,
          type
        })
        .then(res => {
          let { status, body } = res;
          if (status) {
            this.companyList = body.map(item => {
              return {
                text: item.name,
                value: item.id
              };
            });
          }
        });
    },
    _getVisaStatistics(params) {
      this.$api.getVisaStatistics(params).then(res => {
        let { status, body } = res;
        if (status) {
          this.body = body;
        }
      });
    },
    _getVisaList(params) {
      let { current, providerGuid, size } = this;
      params = { providerGuid, ...params, current, size };
      this.$api.getVisaList(params).then(res => {
        let { status, body } = res;
        let { records } = body;
        if (status) {
          this.loading = false;
          this.refreshing = false;

          if (records.length == 0) {
            this.finished = true;
            return;
          }
          this.list = this.list.concat(records);
        }
      });
    },
    handSearch(data) {
      let params = { ...data };
      this.list = [];
      this.current = 1;
      this.params = params;
      this.loading = false;
      this.finished = false;
      this._getVisaList(params);
    },
    chooseAllOrMonth(data) {
      this.tabKey = data == '累计' ? '累计' : '';
    },
    onLoad() {
      this.current++;
      let { params } = this;
      this._getVisaList(params);
    },
    detailClick() {
      this.$router.push({
        name: 'cooperationDetail'
      });
    }
  }
};
</script>

<style scoped lang="scss">
.cooperation-visa-index-container {
  position: relative;
  z-index: 9;
  .visa-change-head {
    min-height: 420px;
    background: transparent;
    margin-top: 10px;
    .visa-change-head-title {
    }
    .visa-details-container {
      width: 100%;
      .top {
        height: 166px;
        border-bottom: 1px solid #efefef;
        width: 100%;
        display: flex;
        div:nth-child(1) {
          width: 33.33%;
          display: flex;
          flex-direction: column;
          align-items: center;
          padding-top: 20px;
          position: relative;
          span:nth-child(1) {
            color: #36c392;
            font-size: 24px;
          }
          span:nth-child(2) {
            margin: 10px 0px 20px 0px;
            color: #000;
            font-size: 32px;
            font-weight: bold;
          }
          span:nth-child(3) {
            color: #666;
            font-size: 24px;
          }
        }
        div:nth-child(1)::after {
          content: '  ';
          width: 1px;
          height: 52px;
          background-color: #f1f1f1;
          margin: 0 auto;
          display: block;
          position: absolute;
          right: 0px;
          top: 74px;
        }
        div:nth-child(2) {
          width: 33.33%;
          display: flex;
          flex-direction: column;
          align-items: center;
          padding-top: 56px;
          position: relative;
          span:nth-child(2) {
            margin-bottom: 20px;
            color: #000;
            font-size: 32px;
            font-weight: bold;
          }
          span:nth-child(3) {
            color: #666;
            font-size: 24px;
          }
        }
        div:nth-child(2)::after {
          content: '  ';
          width: 1px;
          height: 52px;
          background-color: #f1f1f1;
          margin: 0 auto;
          display: block;
          position: absolute;
          right: 0px;
          top: 74px;
        }
      }

      .bottom {
        height: 166px;
        width: 100%;
        display: flex;
        border-bottom: 1px solid #efefef;
        div:nth-child(1) {
          width: 33.33%;
          display: flex;
          flex-direction: column;
          align-items: center;
          padding-top: 20px;
          position: relative;
          span:nth-child(1) {
            color: #36c392;
            font-size: 24px;
          }
          span:nth-child(2) {
            margin: 10px 0px 20px 0px;
            color: #000;
            font-size: 32px;
            font-weight: bold;
          }
          span:nth-child(3) {
            color: #666;
            font-size: 24px;
          }
        }
        div:nth-child(1)::after {
          content: '  ';
          width: 1px;
          height: 52px;
          background-color: #f1f1f1;
          margin: 0 auto;
          display: block;
          position: absolute;
          right: 0px;
          top: 74px;
        }
        div:nth-child(2),
        div:nth-child(3) {
          width: 33.33%;
          display: flex;
          flex-direction: column;
          align-items: center;
          padding-top: 56px;
          position: relative;
          span:nth-child(2) {
            margin-bottom: 20px;
            color: #000;
            font-size: 32px;
            font-weight: bold;
          }
          span:nth-child(3) {
            color: #666;
            font-size: 24px;
          }
        }
        div:nth-child(2)::after {
          content: '  ';
          width: 1px;
          height: 52px;
          background-color: #f1f1f1;
          margin: 0 auto;
          display: block;
          position: absolute;
          right: 0px;
          top: 74px;
        }
      }
      .visa-details-item-many {
        padding-top: 10px;
        width: 33%;
        height: 166px;
        border-bottom: 1px solid #efefef;
      }
      .visa-details-item {
        padding-top: 10px;
        width: 33%;
        height: 166px;
        border-bottom: 1px solid #efefef;
      }
      .visa-details-item:nth-last-child(1) {
        border-bottom: none;
      }
      .visa-details-item:nth-last-child(2) {
        border-bottom: none;
      }
      .visa-details-item:nth-last-child(3) {
        border-bottom: none;
      }
      .visa-details-item-many:nth-last-child(1) {
        border-bottom: none;
      }
      .visa-details-item-many:nth-last-child(2) {
        border-bottom: none;
      }
      .visa-details-item-many:nth-last-child(3) {
        border-bottom: none;
      }
      .visa-details-item-many:nth-last-child(4) {
        border-bottom: none;
      }
    }
  }
  .visa-change-mine {
    margin-top: 10px;
    // background: #f2;
    /deep/ .van-cell {
      position: relative;
      display: flex;
      box-sizing: border-box;
      width: 100%;
      padding: 0px;
      overflow: hidden;
      color: #323233;
      font-size: 0.28rem;
      line-height: 1;
      background-color: transparent;
      margin-bottom: 10px;
    }
    .mine-item {
      background: transparent;
      margin-top: 10px;
      .mine-item-bg {
        background: #efefef;
        height: 10px;
      }
    }
    .mine-item:nth-child(2) {
      margin-top: 0 !important;
    }
  }
}
</style>
